import React, { Component } from 'react'
import { Link } from 'react-router-dom'

export class Footer extends Component {


  render () {
    return (
          <div className="px-4 py-5 footer" >
            <div className="text-center">
              <div>READY TO GET STARTED?</div>
              <div className='mb-4'>Let’s bring your next event to a new level.</div>
              <div className='d-flex justify-content-center mb-5'>
                <Link to='/enquiry'>
                  <button className='btn btn-primary d-flex align-items-center mb-3 mr-3'>
                    <span className='pr-5'>Schedule a Demo</span>
                    <img alt='' src='img/button-arrow.svg' style={{width: '10.4px', height: '12px'}} />
                  </button>
                </Link>
              </div>
              <div className='d-md-flex justify-content-center mb-4' style={{fontSize: '0.7rem'}}>
                <Link to='/careers'><div className='my-1 mx-3 footer--link'>Careers</div></Link>
                <Link to='/cookie'><div className='my-1 mx-3 footer--link'>Cookie Policy</div></Link>
                <Link to='/privacy'><div className='my-1 mx-3 footer--link'>Privacy Policy</div></Link>
                <Link to='/terms'><div className='my-1 mx-3 footer--link'>Terms & Conditions</div></Link>
                <Link to='/enquiry'><div className='my-1 mx-3 footer--link'>Contact</div></Link>
              </div>
              <div style={{fontSize: '0.7rem'}}>OWLGO © 2024 All rights reserved.</div>
            </div>
          </div>
    )
  }
}

export default Footer


// WEBPACK FOOTER //
// ./src/components/footer/Footer.js